import { Method, Request, sendRequest } from "@myloc/myloc-utils";
import defaultRestOptions from "../../../../services/utils/defaultRestOptions";
import { api } from "../config/settings";
import { OpenIdRef, Token, TokenResponse } from "./../types";

export async function exchangeToken(openIdRef: OpenIdRef): Promise<TokenResponse> {
  const url = api.openid.exchangeToken();

  const request = new Request(url, Method.POST);

  const response = await sendRequest(request, openIdRef, await defaultRestOptions());

  return {
    isOk: response.isOk(),
    message: response.message,
    data: typeof response.data === "object" ? (response.data as Token) : undefined,
  };
}
